/** A legacy ready hint cannot skip common profile setup for an HQ-only business account. */
export function requiresHeadquartersOnboarding(scopes: readonly {
  role: string; persona: string; resource: Record<string, unknown>;
}[]): boolean {
  return scopes.length > 0 && scopes.every(scope => ['hqAudit', 'hqSafety'].includes(scope.role)
    && ['hq-staff', 'hq-auditor', 'hq-safety-admin'].includes(scope.persona))
    && scopes.some(scope => scope.resource.kind === 'tenant');
}
